// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

/** * Note: StrictMode is removed to prevent double-initialization bugs 
 * on mobile and performance-heavy components (3D Canvas & Video).
 */
root.render(
    <App />
);

/** * SERVICE WORKER & CACHE RESET LOGIC
 * 1. We first clear old registrations to prevent 404 errors on stale assets.
 * 2. We then register the specific Firebase Messaging Service Worker.
 */
if ('serviceWorker' in navigator) {
  // Clear old workers
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister();
      console.log('Old Service Worker Unregistered - Cache Cleared');
    }

    // Register the new Firebase Messaging Service Worker
    // This looks for the file in your /public folder
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('Firebase Service Worker registered with scope:', registration.scope);
      })
      .catch((err) => {
        console.error('Firebase Service Worker registration failed:', err);
      });
  });
                                                  }
                      
